import { useAtom } from "jotai";
import "../css/tvView.css";
import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useItemsFilter } from "../../_helper/actions/app/items";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import { toast } from "react-toastify";
import CuSpinner from "../../common_component/component/CuSpinner";
import { useNavigate } from "react-router-dom";
import { ApiEndPoint } from "../../_helper/constant/api-types";
// import { useSecureUpdateItem, useCreateItem } from "./utils"; // Import useSecureUpdateItem and useCreateItem from a common file

const TvView = () => {
  const [clinic] = useAtom(clinicAtom);
  const navigate = useNavigate();
  const [data, setData] = useState({
    fields: [
      { id: 1, name: "Token", checked: false },
      { id: 2, name: "Name", checked: false },
      { id: 3, name: "Consulting_Doctor", checked: false },
      { id: 4, name: "Time", checked: false },
      { id: 5, name: "Cabin_Number", checked: false },
    ],
    timing: {
      flag: { auto: false, morning: false, evening: false, custom: false },
      timing: { start_time: null, end_time: null },
    },
    note: "",
  });

  const [value, setValue] = useState("");
  const filter = `?action=getTvViewPermissions&backend=True&clinic_id=${clinic?.id}`;
  const { data: clinicData } = useItemsFilter(
    ApiEndPoint.CLINIC,
    filter,
    clinic?.id ? true : false
  );

  useEffect(() => {
    if (clinicData && clinicData.length > 0) {
      const clinicItem = clinicData[0];
      // const updatedFields = data.fields.map((field) =>
      //   clinicItem.fields.some((clinicField) => clinicField.name === field.name)
      //     ? { ...field, checked: true }
      //     : field
      // );
      const updatedFields = data.fields.map((field) => {
        const clinicField = clinicItem.fields.find(
          (clinicField) => clinicField.name === field.name
        );
        return {
          ...field,
          checked: clinicField ? clinicField.checked : false,
        };
      });

      const updatedTimingFlag = { ...data.timing.flag };
      for (const key in clinicItem.timing.flag) {
        updatedTimingFlag[key] = clinicItem.timing.flag[key];
      }
      const updatedTiming = {
        flag: updatedTimingFlag,
        timing: { ...clinicItem.timing.timing },
      };
      setData({
        fields: updatedFields,
        timing: updatedTiming,
        note: clinicItem.note,
      });
      setValue(clinicItem.note);
    }
  }, [clinicData]);

  // //("clinic data-------", clinicData[0]?.id);

  const handleFieldChange = (fieldName) => {
    const updatedFields = data?.fields.map((field) =>
      field.name === fieldName ? { ...field, checked: !field.checked } : field
    );
    setData({ ...data, fields: updatedFields });
  };

  // const handleTimingOptionChange = (timingOption) => {
  //   const updatedTiming = {
  //     ...data.timing,
  //     flag: {
  //       auto: timingOption === "Auto",
  //       morning: timingOption === "Morning",
  //       evening: timingOption === "Evening",
  //       custom: timingOption === "Custom",
  //     },
  //   };
  //   setData({ ...data, timing: updatedTiming });
  // };

  const handleTimingOptionChange = (timingOption) => {
    let updatedTiming = { ...data.timing };

    // Depending on the selected timing option, update start and end time
    switch (timingOption) {
      case "Auto":
        updatedTiming.timing.start_time = null;
        updatedTiming.timing.end_time = null;
        break;
      case "Morning (9am to 5pm)":
        updatedTiming.timing.start_time = "09:00";
        updatedTiming.timing.end_time = "17:00";
        break;
      case "Evening (6pm to 11pm)":
        updatedTiming.timing.start_time = "18:00";
        updatedTiming.timing.end_time = "23:00";
        break;
      default:
        // For Custom timing, keep the existing values
        break;
    }

    // Update the timing flag
    updatedTiming = {
      ...updatedTiming,
      flag: {
        auto: timingOption === "Auto",
        morning: timingOption === "Morning (9am to 5pm)",
        evening: timingOption === "Evening (6pm to 11pm)",
        custom: timingOption === "Custom",
      },
    };

    setData({ ...data, timing: updatedTiming });
  };

  const updateMutation = useSecureUpdateItem(ApiEndPoint.CLINIC);
  const createMutation = useCreateItem(ApiEndPoint.CLINIC);

  const handleSave = () => {
    // const mutation = clinicData ? updateMutation : createMutation;
    const payload = {
      id: clinicData[0]?.id,
      status: "draft",
      action:
        clinicData?.length > 0
          ? "patchTvViewPermissions"
          : "postTvViewPermissions",
      backend: "True",
      sort: 0,
      fields: data.fields,
      clinic_id: clinic?.id,
      timing: data.timing,
      note: value,
    };

    if (clinicData?.length > 0) {
      updateMutation.mutate(
        { data: payload },
        {
          onSuccess: (data) => {
            toast.success("Successfully Upldated");
            navigate("/new/clinicshow");
            //("Successfully saved:", data);
          },
          onError: (err) => {
            //("Error:", err);
          },
        }
      );
    } else {
      createMutation.mutate(payload, {
        onSuccess: (data) => {
          //("Successfully saved:", data);
          toast.success("Successfully Saved");
        },
        onError: (err) => {
          //("Error:", err);
        },
      });
    }
  };

  const handleCancel = () => {
    // Implement cancel functionality if needed
  };

  return (
    <div className="w-full h-screen">
      {/* <div className="border-b lg:mt-5 w-full font-bold text-xl text-[#000000CC]">
        Tv View
      </div> */}
      {/* Choose Fields */}
      <div className="">
        <div className="w-full font-bold text-xl text-[#000000CC]">
          Choose Fields
        </div>
        <div className="mt-2 flex gap-5 lg:gap-10 flex-wrap">
          {data.fields.map((field) => (
            <div className="flex items-center gap-3 text-sm" key={field.id}>
              <label className="cu-patient-checkbox-cont">
                <input
                  type="checkbox"
                  onChange={() => handleFieldChange(field.name)}
                  checked={field.checked}
                  className="focus:ring-green-500 mr-3"
                />
                <span className="cu-checkbox-checkbox"></span>
                {field.name}
              </label>
            </div>
          ))}
        </div>
      </div>
      {/* Set Timings */}
      <div className="mt-4">
        <div className="w-full mt-10 font-bold text-xl text-[#000000CC]">
          Set Timings
        </div>
        <div className="mt-2 flex gap-5 md:gap-10 flex-wrap">
          {/* {[
            "Auto",
            "Morning (9am to 5pm)",
            "Evening (6pm to 11pm)",
            "Custom",
          ].map((timingOption) => (
            <div className="flex items-center gap-3 text-sm" key={timingOption}>
              <label className="cu-patient-radio-cont">
                <input
                  type="radio"
                  name="timing"
                  value={timingOption}
                  onChange={() => handleTimingOptionChange(timingOption)}
                  checked={data.timing.flag[timingOption.toLowerCase()]}
                />
                <span className="cu-checkmark-radio"></span>
                {timingOption}
              </label>
            </div>
          ))} */}

          {[
            "Auto",
            "Morning (9am to 5pm)",
            "Evening (6pm to 11pm)",
            "Custom",
          ].map((timingOption) => (
            <div className="flex items-center gap-3 text-sm" key={timingOption}>
              <label className="cu-patient-radio-cont">
                <input
                  type="radio"
                  name="timing"
                  value={timingOption}
                  onChange={() => handleTimingOptionChange(timingOption)}
                  checked={
                    data.timing.flag[timingOption.split(" ")[0].toLowerCase()]
                  }
                />
                <span className="cu-checkmark-radio"></span>
                {timingOption}
              </label>
            </div>
          ))}
        </div>
        {data.timing.flag.custom && (
          <div className="flex gap-10 mt-6">
            <div className="w-[200px] flex flex-col">
              <div className="text-sm">Start Time</div>
              <input
                type="time"
                value={data.timing.timing.start_time || ""}
                onChange={(e) =>
                  setData({
                    ...data,
                    timing: {
                      ...data.timing,
                      timing: {
                        ...data.timing.timing,
                        start_time: e.target.value,
                      },
                    },
                  })
                }
                className="w-full h-12 outline-none border border-[#E2E1E5] rounded px-2"
              />
            </div>
            <div className="w-[200px] flex flex-col">
              <div className="text-sm">End Time</div>
              <input
                type="time"
                value={data.timing.timing.end_time || ""}
                onChange={(e) =>
                  setData({
                    ...data,
                    timing: {
                      ...data.timing,
                      timing: {
                        ...data.timing.timing,
                        end_time: e.target.value,
                      },
                    },
                  })
                }
                className="w-full h-12 outline-none border border-[#E2E1E5] rounded px-2"
              />
            </div>
          </div>
        )}
      </div>
      {/* ReactQuill Editor */}
      <div className="mt-10">
        <ReactQuill
          theme="snow"
          value={value}
          onChange={setValue}
          placeholder="Type here, your Instructions on notice board"
          className="sub-texteditor"
          id="editor"
        />
      </div>
      {/* Save and Cancel Buttons */}
      <div className="flex gap-4 mt-10">
        <button
          className="h-11 w-[156px] rounded-[5px] border border-[#00000033]"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="h-11 w-[156px] rounded-[5px] border border-[#00000033] bg-[#EBF8EC]"
        >
          {updateMutation.isLoading ? <CuSpinner /> : "Save"}
        </button>
      </div>
    </div>
  );
};

export default TvView;
